import * as types from '../mutation-types.js'

const state = {
    isScenePicturePlay: '',
    duration: '',
    currentSeconds: '',
    index: '',
    musicUrl: '',
    audioTag: '',
    sceneId: '',
    isComeFromShare: false,
    timer: null,
    logs: []
}

const getters = {
    isScenePicturePlay: state => state.isScenePicturePlay,
    duration: state => state.duration,
    currentSeconds: state => state.currentSeconds,
    index: state => state.index,
    musicUrl: state => state.musicUrl,
    audioTag: state => state.audioTag,
    sceneId: state => state.sceneId,
    isComeFromShare: state => state.isComeFromShare,
    errorLogs: state => state.errorLog.logs
}

const mutations = {
    [types.GET_SECONDS](state, currentSeconds) {
        state.currentSeconds = currentSeconds
        state.audioTag.currentTime = currentSeconds
    },
    [types.GET_INDEX](state, index) {
        state.index = index
    },
    [types.GET_MUSICURL](state, musicUrl) {
        state.musicUrl = musicUrl
    },
    [types.GET_AUDIOTAG](state, audioTag) {
        state.audioTag = audioTag
    },
    [types.GET_AUDIOTAGPLAY](state, audioTagPlay) {
        if (!state.isScenePicturePlay) {
            state.audioTag.play()
            state.isScenePicturePlay = true
            state.duration = state.audioTag.duration
            state.timer = setInterval(() => {
                state.currentSeconds = parseInt(state.audioTag.currentTime)
                if (state.audioTag.currentTime === state.audioTag.duration) {
                    state.duration = 0
                    state.isScenePicturePlay = false
                    state.currentSeconds = 0
                    state.audioTag.pause()
                    clearInterval(state.timer)
                }
            }, 1000)
        } else {
            state.isScenePicturePlay = false
            clearInterval(state.timer)
            state.audioTag.pause()
        }
    },
    [types.GET_SCENEID](state, sceneId) {
        state.sceneId = sceneId
    },
    [types.SET_COME_FROM](state, isComeFromShare) {
        state.isComeFromShare = isComeFromShare
    },
    [types.RESET_ALL](state) {
        state.isScenePicturePlay = false
        state.currentSeconds = 0
        state.duration = 0
    },
    ADD_ERROR_LOG: (state, log) => {
        state.logs.push(log)
    }
}

const actions = {
    getDuration({ state, commit }, duration) {
        commit(types.GET_DURATION, duration)
    },
    getCurrentSeconds({ state, commit }, currentSeconds) {
        commit(types.GET_SECONDS, currentSeconds)
    },
    getIndex({ state, commit }, index) {
        commit(types.GET_INDEX, index)
    },
    getMusicUrl({ state, commit }, musicUrl) {
        commit(types.GET_MUSICURL, musicUrl)
    },
    getAudioTag({ state, commit }, audioTag) {
        commit(types.GET_AUDIOTAG, audioTag)
    },
    getAudioTagPlay({ state, commit }, audioTagPlay) {
        commit(types.GET_AUDIOTAGPLAY, audioTagPlay)
    },
    getSceneId({ state, commit }, sceneId) {
        commit(types.GET_SCENEID, sceneId)
    },
    setComeFrom({ state, commit }, isComeFromShare) {
        commit(types.SET_COME_FROM, isComeFromShare)
    },
    resetAll({ state, commit }) {
        commit(types.RESET_ALL)
    },
    addErrorLog({ commit }, log) {
        commit('ADD_ERROR_LOG', log)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/viewtable/index.js